import { Flex, LoadingOverlay, Tabs } from '@mantine/core';
import { useEffect, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { BackButton, TextInput } from '@components';
import { useForwarder } from '@hooks/forwarder';
import { ApiAccess } from './ApiAccess';
import { ForwarderViewBusinessCard } from './ForwarderViewBusinessCard';

interface ForwarderViewParams {
  disabled?: boolean;
}

export const ForwarderView: React.FC<ForwarderViewParams> = ({ disabled }) => {
  const navigate = useNavigate();
  const { id, tabId } = useParams<{ id: string; tabId?: string }>() as any;
  const { data: forwarder, isLoading } = useForwarder(id);

  const basePath = `/forwarders/${id}`;

  const activeTab = useMemo(() => tabId || 'business-card', [tabId]);

  useEffect(() => {
    if (!tabId) {
      navigate(`${basePath}/business-card`);
    }
  }, [tabId, navigate]);

  const handleTabChange = (newTab: string) => {
    navigate(`${basePath}/${newTab}`);
  };

  if (!forwarder) {
    return <LoadingOverlay visible={isLoading} overlayProps={{ radius: 'sm', blur: 2 }} />;
  }

  return (
    <>
      <Flex justify="space-between" pl="md" pr="xl" my="xl" mx="xl">
        <BackButton backPath="/forwarders"></BackButton>
        <TextInput name="name" label="Forwarder name" value={forwarder?.name} disabled />
      </Flex>

      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        orientation="vertical"
        keepMounted={false}
        px={20}
        styles={{
          panel: { padding: '0px 30px' },
        }}
      >
        <Tabs.List>
          <Tabs.Tab value="business-card">Business card informations</Tabs.Tab>
          <Tabs.Tab value="api-access">Allow API access</Tabs.Tab>
        </Tabs.List>

        <Tabs.Panel value="business-card">
          <ForwarderViewBusinessCard forwarder={forwarder} />
        </Tabs.Panel>
        <Tabs.Panel value="api-access">
          <ApiAccess forwarder={forwarder} readonly={disabled} />
        </Tabs.Panel>
      </Tabs>
    </>
  );
};
